import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Roles from './pages/Roles';
import RoutesPage from './pages/Routes';
import Plans from './pages/Plans';
import Tasks from './pages/Tasks';
import Integrations from './pages/Integrations';
import Campaigns from './pages/Campaigns';
import Orders from './pages/Orders';
import Settings from './pages/Settings';
import Files from './pages/Files';
import PromoCodes from './pages/PromoCodes';
import Realtime from './pages/Realtime';
import AppMaintenance from './pages/AppMaintenance';
import AuditLogs from './pages/AuditLogs';
import Organizations from './pages/Organizations';
function useMe() {
    return useQuery({
        queryKey: ['me'],
        queryFn: async () => {
            const res = await fetch('/api/auth/me', { credentials: 'include' });
            if (!res.ok)
                return null;
            const data = await res.json();
            if (!data.user || data.user.scope !== 'admin')
                return null;
            return data.user;
        },
    });
}
export default function App() {
    const { data: user, isLoading } = useMe();
    if (isLoading) {
        return _jsx("div", { className: "flex h-screen items-center justify-center text-slate-400", children: "Loading..." });
    }
    if (!user) {
        return _jsx(Login, {});
    }
    return (_jsx(Routes, { children: _jsxs(Route, { path: "/", element: _jsx(Layout, {}), children: [_jsx(Route, { index: true, element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "users", element: _jsx(Users, {}) }), _jsx(Route, { path: "roles", element: _jsx(Roles, {}) }), _jsx(Route, { path: "routes", element: _jsx(RoutesPage, {}) }), _jsx(Route, { path: "plans", element: _jsx(Plans, {}) }), _jsx(Route, { path: "tasks", element: _jsx(Tasks, {}) }), _jsx(Route, { path: "integrations", element: _jsx(Integrations, {}) }), _jsx(Route, { path: "campaigns", element: _jsx(Campaigns, {}) }), _jsx(Route, { path: "orders", element: _jsx(Orders, {}) }), _jsx(Route, { path: "files", element: _jsx(Files, {}) }), _jsx(Route, { path: "promo-codes", element: _jsx(PromoCodes, {}) }), _jsx(Route, { path: "settings", element: _jsx(Settings, {}) }), _jsx(Route, { path: "realtime", element: _jsx(Realtime, {}) }), _jsx(Route, { path: "app-maintenance", element: _jsx(AppMaintenance, {}) }), _jsx(Route, { path: "audit-logs", element: _jsx(AuditLogs, {}) }), _jsx(Route, { path: "organizations", element: _jsx(Organizations, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }) }));
}
